import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/components/headers/global_header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/not_found_section.tsx");
